import React, { useRef, useEffect } from "react";
import Container from "../../UI/Container/Container";
import classes from "./MargeeQuote.module.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const MargeeQuote = (props) => {
  gsap.registerPlugin(ScrollTrigger);

  const quoteRef = useRef(null);

  useEffect(() => {
    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: quoteRef.current,
        start: "bottom bottom",
      },
    });

    timeline.to(quoteRef.current, { opacity: 1, duration: 1 });
  });

  return (
    <div className={classes.MargeeQuote}>
      <Container>
        <blockquote ref={quoteRef}>
          <p className="kepler">
            I definitely am a good product of the liberal arts, and it’s served me incredibly well. The liberal arts … engaged my curiosity, and I do
            think people who are successful in business have a natural curiosity—they question things, they want to understand how things work, why
            things have been decided or why things have happened the way they’ve happened. Dickinson prepared me for that really well.
          </p>
          <cite>
            — STEVE SMITH ’92 (FINE ARTS AND PHYSICS) <br />
            RED DEVIL BASKETBALL PLAYER; PRESIDENT AND CEO OF L.L.BEAN
          </cite>
        </blockquote>
      </Container>
    </div>
  );
};

export default MargeeQuote;
